// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-section {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  display: flex;
  align-items: center;
  position: relative;
}
.login-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(212, 175, 55, 0.05) 0%, transparent 100%);
  pointer-events: none;
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(212, 175, 55, 0.2);
  position: relative;
}
.login-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(212, 175, 55, 0.02) 0%, transparent 100%);
  border-radius: 20px;
  pointer-events: none;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}
.logo-container .logo-a, .logo-container .logo-h {
  font-family: "Arial", sans-serif;
  font-weight: 900;
  font-size: 36px;
  line-height: 1;
}
.logo-container .logo-a {
  color: #1a1a1a;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-right: 2px;
}
.logo-container .logo-h {
  color: #d4af37;
  text-shadow: 0 2px 4px rgba(212, 175, 55, 0.3);
  margin-right: 16px;
}
.logo-container .brand-login {
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #2d2d2d;
}

.login-title {
  font-family: "Helvetica Neue", Arial, sans-serif;
  font-weight: 300;
  font-size: 28px;
  color: #2d2d2d;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.login-subtitle {
  color: #666;
  font-size: 16px;
  font-weight: 300;
  margin: 0;
}

.login-form .form-group {
  margin-bottom: 24px;
}
.login-form .form-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #2d2d2d;
  margin-bottom: 8px;
  font-size: 14px;
}
.login-form .form-label .input-icon {
  color: #d4af37;
  margin-right: 8px;
  font-size: 18px;
}
.login-form .modern-input {
  background: rgba(255, 255, 255, 0.8);
  border: 2px solid rgba(212, 175, 55, 0.2);
  border-radius: 12px;
  padding: 16px 20px;
  font-size: 16px;
  transition: all 0.3s ease;
  color: #2d2d2d;
}
.login-form .modern-input::placeholder {
  color: #999;
  font-weight: 300;
}
.login-form .modern-input:focus {
  outline: none;
  border-color: #d4af37;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.1);
  transform: translateY(-1px);
}

.login-btn {
  width: 100%;
  background: linear-gradient(45deg, #d4af37, #b8860b);
  border: none;
  border-radius: 12px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
  margin-top: 32px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(212, 175, 55, 0.4);
  background: linear-gradient(45deg, #daa520, #cd853f);
}
.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.login-btn .btn-icon {
  font-size: 20px;
}

.error-message {
  display: flex;
  align-items: center;
  color: #e74c3c;
  font-size: 14px;
  margin-top: 8px;
}
.error-message .error-icon {
  font-size: 16px;
  margin-right: 6px;
}

.error-alert {
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.3);
  border-radius: 12px;
  padding: 16px;
  margin-top: 24px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.error-alert .alert-icon {
  color: #e74c3c;
  font-size: 20px;
  margin-top: 2px;
}
.error-alert strong {
  color: #e74c3c;
  display: block;
  margin-bottom: 4px;
}
.error-alert p {
  color: #c0392b;
  margin: 0;
  font-size: 14px;
}

.success-alert {
  background: rgba(39, 174, 96, 0.1);
  border: 1px solid rgba(39, 174, 96, 0.3);
  border-radius: 12px;
  padding: 16px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #27ae60;
}
.success-alert .success-icon {
  font-size: 20px;
}

.login-footer {
  text-align: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(212, 175, 55, 0.2);
}
.login-footer p {
  color: #666;
  margin: 0;
  font-size: 14px;
}
.login-footer .signup-link {
  color: #d4af37;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}
.login-footer .signup-link:hover {
  color: #b8860b;
  text-shadow: 0 1px 2px rgba(212, 175, 55, 0.3);
}

@media (max-width: 768px) {
  .login-card {
    margin: 20px;
    padding: 30px 24px;
  }
  .login-title {
    font-size: 24px;
  }
  .logo-container .logo-a, .logo-container .logo-h {
    font-size: 32px;
  }
  .logo-container .brand-login {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/signup/signup.component.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAEE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iFAAA;EACA,oBAAA;AAAJ;;AAIA;EACE,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,8EAAA;EACA,yCAAA;EACA,kBAAA;AADF;AAGE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iFAAA;EACA,mBAAA;EACA,oBAAA;AADJ;;AAKA;EACE,kBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;AAIE;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAFJ;AAKE;EACE,cAAA;EACA,yCAAA;EACA,iBAAA;AAHJ;AAME;EACE,cAAA;EACA,8CAAA;EACA,kBAAA;AAJJ;AAOE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AALJ;;AASA;EACE,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AANF;;AASA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AANF;;AAUE;EACE,mBAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AARJ;AAUI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AARN;AAYE;EACE,oCAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AAVJ;AAYI;EACE,WAAA;EACA,gBAAA;AAVN;AAaI;EACE,aAAA;EACA,qBAAA;EACA,qCAAA;EACA,6CAAA;EACA,2BAAA;AAXN;;AAgBA;EACE,WAAA;EACA,oDAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAbF;AAeE;EACE,2BAAA;EACA,8CAAA;EACA,oDAAA;AAbJ;AAgBE;EACE,YAAA;EACA,mBAAA;AAdJ;AAiBE;EACE,eAAA;AAfJ;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAhBF;AAkBE;EACE,eAAA;EACA,iBAAA;AAhBJ;;AAoBA;EACE,kCAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAjBF;AAmBE;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,cAAA;EACA,cAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,cAAA;EACA,SAAA;EACA,eAAA;AAnBJ;;AAuBA;EACE,kCAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AApBF;AAsBE;EACE,eAAA;AApBJ;;AAwBA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6CAAA;AArBF;AAuBE;EACE,WAAA;EACA,SAAA;EACA,eAAA;AArBJ;AAwBE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,2BAAA;AAtBJ;AAwBI;EACE,cAAA;EACA,8CAAA;AAtBN;;AA2BA;EACE;IACE,YAAA;IACA,kBAAA;EAxBF;EA2BA;IACE,eAAA;EAzBF;EA6BE;IACE,eAAA;EA3BJ;EA8BE;IACE,eAAA;EA5BJ;AACF","sourcesContent":["// Import the same styles as login component\n.login-section {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n  display: flex;\n  align-items: center;\n  position: relative;\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(45deg, rgba(212,175,55,0.05) 0%, transparent 100%);\n    pointer-events: none;\n  }\n}\n\n.login-card {\n  background: rgba(255,255,255,0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.1);\n  border: 1px solid rgba(212,175,55,0.2);\n  position: relative;\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(45deg, rgba(212,175,55,0.02) 0%, transparent 100%);\n    border-radius: 20px;\n    pointer-events: none;\n  }\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  \n  .logo-a, .logo-h {\n    font-family: 'Arial', sans-serif;\n    font-weight: 900;\n    font-size: 36px;\n    line-height: 1;\n  }\n  \n  .logo-a {\n    color: #1a1a1a;\n    text-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    margin-right: 2px;\n  }\n  \n  .logo-h {\n    color: #d4af37;\n    text-shadow: 0 2px 4px rgba(212,175,55,0.3);\n    margin-right: 16px;\n  }\n  \n  .brand-login {\n    font-size: 18px;\n    font-weight: 300;\n    letter-spacing: 3px;\n    text-transform: uppercase;\n    color: #2d2d2d;\n  }\n}\n\n.login-title {\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  font-weight: 300;\n  font-size: 28px;\n  color: #2d2d2d;\n  margin-bottom: 8px;\n  letter-spacing: 0.5px;\n}\n\n.login-subtitle {\n  color: #666;\n  font-size: 16px;\n  font-weight: 300;\n  margin: 0;\n}\n\n.login-form {\n  .form-group {\n    margin-bottom: 24px;\n  }\n  \n  .form-label {\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    color: #2d2d2d;\n    margin-bottom: 8px;\n    font-size: 14px;\n    \n    .input-icon {\n      color: #d4af37;\n      margin-right: 8px;\n      font-size: 18px;\n    }\n  }\n  \n  .modern-input {\n    background: rgba(255,255,255,0.8);\n    border: 2px solid rgba(212,175,55,0.2);\n    border-radius: 12px;\n    padding: 16px 20px;\n    font-size: 16px;\n    transition: all 0.3s ease;\n    color: #2d2d2d;\n    \n    &::placeholder {\n      color: #999;\n      font-weight: 300;\n    }\n    \n    &:focus {\n      outline: none;\n      border-color: #d4af37;\n      background: rgba(255,255,255,0.95);\n      box-shadow: 0 0 0 3px rgba(212,175,55,0.1);\n      transform: translateY(-1px);\n    }\n  }\n}\n\n.login-btn {\n  width: 100%;\n  background: linear-gradient(45deg, #d4af37, #b8860b);\n  border: none;\n  border-radius: 12px;\n  padding: 16px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #1a1a1a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n  margin-top: 32px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  \n  &:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(212,175,55,0.4);\n    background: linear-gradient(45deg, #daa520, #cd853f);\n  }\n  \n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n  \n  .btn-icon {\n    font-size: 20px;\n  }\n}\n\n.error-message {\n  display: flex;\n  align-items: center;\n  color: #e74c3c;\n  font-size: 14px;\n  margin-top: 8px;\n  \n  .error-icon {\n    font-size: 16px;\n    margin-right: 6px;\n  }\n}\n\n.error-alert {\n  background: rgba(231,76,60,0.1);\n  border: 1px solid rgba(231,76,60,0.3);\n  border-radius: 12px;\n  padding: 16px;\n  margin-top: 24px;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  \n  .alert-icon {\n    color: #e74c3c;\n    font-size: 20px;\n    margin-top: 2px;\n  }\n  \n  strong {\n    color: #e74c3c;\n    display: block;\n    margin-bottom: 4px;\n  }\n  \n  p {\n    color: #c0392b;\n    margin: 0;\n    font-size: 14px;\n  }\n}\n\n.success-alert {\n  background: rgba(39,174,96,0.1);\n  border: 1px solid rgba(39,174,96,0.3);\n  border-radius: 12px;\n  padding: 16px;\n  margin-top: 24px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #27ae60;\n  \n  .success-icon {\n    font-size: 20px;\n  }\n}\n\n.login-footer {\n  text-align: center;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(212,175,55,0.2);\n  \n  p {\n    color: #666;\n    margin: 0;\n    font-size: 14px;\n  }\n  \n  .signup-link {\n    color: #d4af37;\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.3s ease;\n    \n    &:hover {\n      color: #b8860b;\n      text-shadow: 0 1px 2px rgba(212,175,55,0.3);\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .login-card {\n    margin: 20px;\n    padding: 30px 24px;\n  }\n  \n  .login-title {\n    font-size: 24px;\n  }\n  \n  .logo-container {\n    .logo-a, .logo-h {\n      font-size: 32px;\n    }\n    \n    .brand-login {\n      font-size: 16px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
